module.exports = __webpack_public_path__ + "static/media/Cagliari.14e7ac92.png";